import { useEffect, useState } from "react";

export default function MomentBanner({ moment, onDismiss }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!moment) return;
    setVisible(true);
    try { navigator.vibrate?.([120, 60, 120]); } catch {}
    const t = setTimeout(() => {
      setVisible(false);
      setTimeout(onDismiss, 400);
    }, 9000);
    return () => clearTimeout(t);
  }, [moment, onDismiss]);
  if (!moment) return null;

  const accent = {
    now: "var(--motif-primary)",
    warning: "#f59e0b",
    celebrate: "#16a34a",
    info: "var(--motif-primary)",
  }[moment.kind || "info"];

  return (
    <div
      onClick={() => { setVisible(false); setTimeout(onDismiss, 400); }}
      className={`fixed top-4 left-4 right-4 z-[150] transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4 pointer-events-none"
      }`}
      data-testid="moment-banner"
    >
      <div
        className="glass rounded-2xl p-4 flex items-start gap-3 cursor-pointer"
        style={{ borderLeft: `4px solid ${accent}`, boxShadow: "0 12px 40px rgba(0,0,0,0.18)" }}
      >
        <div className="flex-1">
          <div className="text-[10px] tracking-luxe text-motif-muted mb-0.5">
            {(moment.kind || "info").toUpperCase()} · NOW
          </div>
          <div className="font-display text-lg text-motif leading-snug">{moment.text}</div>
        </div>
        <div className="text-[10px] text-motif-muted ml-2 mt-1">tap</div>
      </div>
    </div>
  );
}
